import React from "react"
import PropTypes from "prop-types"

import { FaCheckCircle } from "react-icons/fa"
import { Button, Modal, ModalBody } from "reactstrap"
import { Spinner } from "reactstrap"

const InspectionPDFDownloadModal = ({
  inspectionDetails,
  show,
  onCloseClick,
  success,
  loading,
  onClickButton,
}) => {
  return (
    <>
      <Modal isOpen={show} toggle={onCloseClick} centered={true}>
        <div>
          <Button
            close
            aria-label="Close"
            onClick={onCloseClick}
            style={{
              position: "absolute",
              right: "0rem",
              top: "0rem",
              zIndex: 10,
            }}
          />
          <ModalBody className="p-4" style={{ minHeight: "150px" }}>
            <div
              className="d-flex flex-column align-items-center justify-content-center text-center text-secondary"
              style={{ minHeight: "160px" }} // leave space below button
            >
              {loading && (
                <div className="text-center">
                  <div className="mb-4">
                    <Spinner size="sm" className="me-2" />
                    {inspectionDetails?.pdf_url?.url
                      ? "Regenerating..."
                      : "Generating... "}
                  </div>
                  <div className="small text-muted">
                    Please don’t close the popup.
                    <br />
                    PDF generation may take a few seconds.
                  </div>
                </div>
              )}
              {success && (
                <div className="text-center">
                  <FaCheckCircle
                    className="text-success mb-3"
                    style={{ fontSize: "40px" }}
                  />
                  <div className="fw-semibold text-dark">
                    Your PDF has been generated.
                  </div>
                  <div className="small text-muted">
                    You may now download it or regenerate if needed.
                  </div>
                </div>
              )}
              {!loading && !success && (
                // <div className="text-center">
                //   <div className="mb-2 fw-semibold text-dark">
                //     Ready to generate your PDF report.
                //   </div>
                //   <div className="small text-muted">
                //     Click the button above to start PDF generation.
                //   </div>
                // </div>
                <div className="text-center">
                  <FaCheckCircle
                    className="text-success mb-3"
                    style={{ fontSize: "40px" }}
                  />
                  <div className="fw-semibold text-dark">
                    Your PDF has been generated.
                  </div>
                  <div className="small text-muted">
                    You may now download it or regenerate if needed.
                  </div>
                </div>
              )}
            </div>
          </ModalBody>
        </div>
      </Modal>
    </>
  )
}

InspectionPDFDownloadModal.propTypes = {
  inspectionDetails: PropTypes.object.isRequired,
  onCloseClick: PropTypes.func,
  show: PropTypes.any,
  success: PropTypes.any,
  loading: PropTypes.any,
  onClickButton: PropTypes.func,
}

export default InspectionPDFDownloadModal
